import React from 'react'
import Aside from '../../Components/aside'
import MaybeComponent from '../../Components/MaybeComponent'
import TopBar from '../../Components/topBar'

function MaybePage() {
  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <MaybeComponent />
      </div>
    </div>
  )
}

export default MaybePage